import React from 'react';
const numberOfPeopleToList = 3;

export default (translate, productSpecificMessageResource, registrants) => {
  const totalNumberOfPeople = registrants.length;
  const namesToShow = registrants.slice(0, numberOfPeopleToList);
  let names = namesToShow.map((reg, idx) =>
    (<li key={idx}>{
      translate('lbl_FullName__resx', {
        firstName: reg.firstName,
        lastName: reg.lastName
      }) + ((totalNumberOfPeople > numberOfPeopleToList &&
        idx === numberOfPeopleToList - 1) ?
        ' ' + translate('EventGuest_Products_MoreThanXValidation__resx', {
          numberOfPeople: totalNumberOfPeople - numberOfPeopleToList
        })
        : '')
    }</li>)
  );
  const errorMessage = (<div>{translate(productSpecificMessageResource)}
    <div><ul>{names}</ul></div>
  </div>);
  return errorMessage;
};
